//
// BrowserFacility.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./UnicodeFacility";
import "./PortableCollator";

var BrowserFacility = createModule("commons::BrowserFacility", ["commons::UnicodeFacility"], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getCollator: [1,7],
        isICUEnabled: [2],
    },
    {
        _create: [4],
    },
    ,
]);
export default BrowserFacility;
